import { combineReducers } from 'redux';

import AuthReducer from '../reducers/AuthReducer';
import enumsReducer from '../reducers/enumsReducer';

export default combineReducers({
   authReducer: AuthReducer,
   enums: enumsReducer,
});
